import Md5 from 'md5'
import Vue from 'vue'
import {
  environment
} from '@/utils/oss.env'
class Utils {
  /**
   * 根据步骤获取指定的TaskDate  0为login  其他必须通过login才能操作
   * 返回步骤最前的 modType为 8  1  Taks
   * 步骤不能做时 TaskDate为null
   */
  getTaskDat(key, seq) {
    let task = null
    if (this.checkTestIsOperation(key, seq)) {
      const tasksData = this.getTasksData(key)
      for (let i = 0; i < tasksData.length; i++) {
        if (tasksData[i].isFinish !== 2 && (tasksData[i].modType === 8 || tasksData[i].modType === 1)) {
          task = tasksData[i]
          break
        }
      }
    }
    return task
  }

  /**
   * 返回指定 ModType类型 并且不为结束的第一个任务
   * @param modType
   * 搜索不到时返回 NUll
   */
  getTaskDataByModType(modType) {
    let task = null
    const tasksData = this.getTasksData()
    for (let i = 0; i < tasksData.length; i++) {
      if (tasksData[i].isFinish !== '2' && tasksData[i].modType === modType) {
        task = tasksData[i]
        break
      }
    }
    return task
  }

  /**
   * 红字发票 (如果 modType对应任务都为结束 则取第一个结束任务数据)
   * @param key
   * @param modType
   */
  getTaskDataRedFontByModType(modType) {
    let task = null
    const tasksData = this.getTasksData()
    for (let i = 0; i < tasksData.length; i++) {
      if (tasksData[i].isFinish !== 2 && tasksData[i].modType === modType) {
        task = tasksData[i]
        break
      }
    }
    if (task == null) {
      for (let i = 0; i < tasksData.length; i++) {
        if (tasksData[i].isFinish === 2 && tasksData[i].modType === modType) {
          task = tasksData[i]
          break
        }
      }
    }
    return task
  }

  putClint(clint) {
    Vue.ls.set('clint', clint)
  }

  putOssTime(key, ossTime) {
    const userInfo = this.getUserInfo(key)
    userInfo.ossTime = ossTime
    this.putUserInfo(key, userInfo)
  }

  putTasksData(key, taskdData) {
    const userInfo = this.getUserInfo(key)
    userInfo.TasksData = taskdData
    this.putUserInfo(key, userInfo)
  }

  getTasksData() {
    const taskData = Vue.ls.get('taskData')
    if (taskData) {
      return taskData
    } else {
      return null
    }
  }
  putEnterprise(key, data) {
    const userInfo = this.getUserInfo(key)
    userInfo.enterprise = data
    this.putUserInfo(key, userInfo)
  }
  getEnterprise(key) {
    const userInfo = this.getUserInfo(key)
    if (userInfo !== null) {
      return userInfo.enterprise
    }
    return null
  }

  /**
   * 根据步骤获取take
   * @param key
   */
  getTasksBySeq(key, seq) {
    const date = this.getTasksData(key)
    if (date !== null && seq < date[seq] !== undefined) {
      return date[seq]
    }
    return null
  }

  /**
   * 根据TakeID获取take
   * @param key
   */
  getTasksByTake(key, taskId) {
    if (taskId === null || taskId.trim() === '') {
      return
    }
    const dates = this.getTasksData(key)
    if (dates !== null) {
      for (const date of (dates)) {
        if (taskId.trim() === date.id) {
          return date
        }
      }
    }
    return null
  }

  putUserInfo(key, userInfo) {
    localStorage.removeItem('KP_USER_' + key)
    if (userInfo) {
      localStorage.setItem('KP_USER_' + key, JSON.stringify(userInfo))
    }
  }

  getUserInfo() {
    const userInfo = Vue.ls.get('loginInfo')
    return userInfo
  }

  getStuId() {
    const userInfo = Vue.ls.get('loginInfo')
    return userInfo ? userInfo.stuId : ''
  }

  getTestType(key) {
    const str = localStorage.getItem('KP_USER_' + key)
    let userInfo = null
    if (str) {
      userInfo = JSON.parse(str)
    }
    return userInfo.testType
  }

  getEid() {
    const userInfo = Vue.ls.get('loginInfo')
    return userInfo ? userInfo.eid : ''
  }

  getToken() {
    const userInfo = Vue.ls.get('loginInfo')
    return userInfo ? userInfo.token : ''
  }

  getTestId() {
    const userInfo = Vue.ls.get('loginInfo')
    return userInfo ? userInfo.testId : ''
  }

  getDomain() {
    const userInfo = Vue.ls.get('loginInfo')
    return userInfo ? userInfo.domain : ''
  }

  getOssTime(key) {
    const str = localStorage.getItem('KP_USER_' + key)
    let userInfo = null
    if (str) {
      userInfo = JSON.parse(str)
    }
    return userInfo.ossTime
  }

  getClint() {
    const clint = Vue.ls.get('clint')
    if (clint) {
      return clint
    } else {
      return null
    }
  }

  getOpenModuleId(key) {
    const str = localStorage.getItem('KP_USER_' + key)
    let userInfo = null
    if (str) {
      userInfo = JSON.parse(str)
    }
    return userInfo.openModuleId
  }

  getBankType(key) {
    const str = localStorage.getItem('KP_USER_' + key)
    let userInfo = null
    if (str) {
      userInfo = JSON.parse(str)
    }
    return userInfo.bankType
  }

  orgId(key) {
    const str = localStorage.getItem('KP_USER_' + key)
    let userInfo = null
    if (str) {
      userInfo = JSON.parse(str)
    }
    return userInfo.orgId
  }

  isEmpty(str) {
    if (str === undefined || str === null || str.length < 1 || str.toLocaleLowerCase() === 'null') {
      return true
    }
    return false
  }

  md5Str(str) {
    return Md5(str) + ''
  }

  getUidForHref() {
    var uid = ''
    var hrefs = window.location.href.split('?')
    if (hrefs.length >= 2) {
      var paramStr = hrefs[1]
      //  参数字符串里有没带 =?/#
      uid = paramStr.split('=')[0]
      uid = uid.split('?')[0]
      uid = uid.split('/')[0]
      uid = uid.split('#')[0]
      uid = uid.split('/')[0]
    }
    return uid
  }

  //   判断空对象 true为空对象
  checkObjectOfNull(data) {
    const flag = (JSON.stringify(data) === '{}')
    return flag
  }

  searchData(result) {
    const param = {
      showCount: 1,
      currentPage: 1,
    }
    if (result) {
      const num = parseInt(result, 10)
      if (!isNaN(num)) {
        param['code'] = result
      } else {
        param['name'] = result
      }
    }
    return param
  }

  /**
   * 数字金额转化中文金额
   * @param money
   */
  convertCurrency(money) {
    let fushu = ''
    let flag = false
    if (money < 0) {
      fushu = '(负数：)'
      flag = true
    }
    money = Math.abs(money)
    //   汉字的数字
    var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    //  基本单位
    var cnIntRadice = ['', '拾', '佰', '仟']
    //  对应整数部分扩展单位
    var cnIntUnits = ['', '万', '亿', '兆']
    //   对应小数部分单位
    var cnDecUnits = ['角', '分', '毫', '厘']
    //   整数金额时后面跟的字符
    var cnInteger = '整'
    //   整型完以后的单位
    var cnIntLast = '元'
    //   最大处理的数字
    var maxNum = 999999999999999.9999
    //   金额整数部分
    var integerNum
    //   金额小数部分
    var decimalNum
    //   输出的中文金额字符串
    var chineseStr = ''
    //   分离金额后用的数组，预定义
    var parts
    if (money === '') {
      return ''
    }
    money = parseFloat(money)
    if (money >= maxNum) {
      //   超出最大处理数字
      return ''
    }
    if (money === 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger
      return chineseStr
    }
    //   转换为字符串
    money = money.toString()
    if (money.indexOf('.') === -1) {
      integerNum = money
      decimalNum = ''
    } else {
      parts = money.split('.')
      integerNum = parts[0]
      decimalNum = parts[1].substr(0, 4)
    }
    //   获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0
      var IntLen = integerNum.length
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1)
        var p = IntLen - i - 1
        var q = p / 4
        var m = p % 4
        if (n === '0') {
          zeroCount++
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0]
          }
          //   归零
          zeroCount = 0
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
        }
        if (m === 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q]
        }
      }
      chineseStr += cnIntLast
    }
    //   小数部分
    if (decimalNum !== '') {
      const decLen = decimalNum.length
      for (let i = 0; i < decLen; i++) {
        const n = decimalNum.substr(i, 1)
        if (n !== '0') {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i]
        }
      }
    }
    if (chineseStr === '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger
    } else if (decimalNum === '') {
      chineseStr += cnInteger
    }
    if (flag) {
      chineseStr = fushu + chineseStr
    }
    return chineseStr
  }

  /**
   * 数字保留两位小数
   * @param num
   */

  keepTwoDecimalFull(num) {
    if (isNaN(num)) {
      return
    }
    num = Math.round(num * 100) / 100
    let sx = num.toString()
    let posdecimal = sx.indexOf('.')
    if (posdecimal < 0) {
      posdecimal = sx.length
      sx += '.'
    }
    while (sx.length <= posdecimal + 2) {
      sx += '0'
    }
    const n = parseFloat(sx)
    return n
  }

  /**
   * 金额校验
   * @param num
   */
  isMoney(num) {
    const isNum = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
    const reg = new RegExp(isNum)
    if (!reg.test(num)) { //  非法输入
      if (num === 0) {
        return '0.00'
      }
      return ''
    } else {
      if (num.indexOf('.') === -1) { //  没有小数点
        num = num + '.00'
      }
      //  整数超过3位加 ，
      const numArray = num.split('.')
      const numArrayson = numArray[0].split('')
      num = ''
      const one = numArrayson.length % 3
      for (let i = 0; i < numArrayson.length; i++) {
        num = num + numArrayson[i]
        if (i !== numArrayson.length - 1 && (i + 1 - one) % 3 === 0) {
          num = num + ','
        }
      }
      num = num + '.' + numArray[1]
      return num
    }
  }

  /**
   * 时间格式化
   * @param time
   */
  formatDate(time) {
    const date = new Date(time)

    const year = date.getFullYear()
    const month = date.getMonth() + 1 //  月份是从0开始的
    const day = date.getDate()
    /* hour = date.getHours(),
    min = date.getMinutes(),
    sec = date.getSeconds() */
    const preArr = Array.apply(null, Array(10)).map(function (elem, index) {
      return '0' + index
    }) //  开个长度为10的数组 格式为 00 01 02 03
    const newTime = year +
      (preArr[month] || month) +
      (preArr[day] || day)
    return newTime
  }

  /**
   * 拼接 视频地址  数据格式错返回null
   * @param videoId
   * @param video
   */
  videoUrl(videoId, video) {
    const videoUrl = null
    if (video !== null && videoId !== undefined) {
      if (video.pu !== undefined && video.timestamp !== undefined && video.format !== undefined && video.sign !== undefined) {
        return environment.videoPrefix + '&videoId=' + videoId +
          '&pu=' + video.pu + '&timestamp=' + video.timestamp + '&format=' + video.format + '&sign=' + video.sign + '&df=3'
      }
    }

    return videoUrl
  }
}
// const Utils = new Utils()
export default new Utils()
